import { User } from '@sr/types';
import React from 'react';
import { Box, Text, backgroundTransition } from './index';

const Avatar = ({
  user,
  size = 32,
  isDark = false,
}: {
  user: User | null;
  size?: number;
  isDark?: boolean;
}) => {
  return (
    <Box
      variant="flex.center"
      sx={{
        width: size,
        height: size,
        borderRadius: 9999,
        backgroundColor: isDark ? 'buttonGrayDark' : 'buttonGray',
        transition: `background-color ${backgroundTransition}`,
        flexShrink: 0,
      }}
    >
      <Text
        sx={{
          variant: 'text.base',
          textTransform: 'uppercase',
          color: isDark ? 'white50' : 'black50',
          transition: `color ${backgroundTransition}`,
        }}
      >
        {getInitials(user)}
      </Text>
    </Box>
  );
};

function getInitials(user: User | null): string {
  if (user && user.firstName && user.lastName) {
    return `${user.firstName[0]}${user.lastName[0]}`;
  } else {
    return '';
  }
}

export { Avatar };
